import { NoteType } from '../../common/types';
import { HistoryType } from '../recruitments/Recruitments.types';

import { ReminderType } from './useGetRecruitmentReminders';

export function isNote(note: NoteType | HistoryType | ReminderType): note is NoteType {
  return (note as NoteType).content !== undefined;
}

export function isReminder(note: NoteType | HistoryType | ReminderType): note is ReminderType {
  return (note as ReminderType).objectClass !== undefined;
}

export function isHistory(note: NoteType | HistoryType | ReminderType): note is HistoryType {
  return (note as HistoryType).statusName !== undefined;
}
